import type { ToothFullHeadMPR } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

type FullHeadMprWriteResponse = { ToothFullHeadMPR?: ToothFullHeadMPR };

const pendingWrites: Record<string, Promise<FullHeadMprWriteResponse>> = {};

export const queueFullHeadMprWrite = <T extends FullHeadMprWriteResponse>({
  toothID,
  write,
}: {
  toothID: string;
  write: (previous?: ToothFullHeadMPR) => Promise<T>;
}): Promise<T> => {
  const previous: Promise<FullHeadMprWriteResponse> =
    pendingWrites[toothID] ?? Promise.resolve({});
  const current = previous.then(
    (response) => write(response.ToothFullHeadMPR),
    () => write(),
  );
  pendingWrites[toothID] = current;
  const release = () => {
    if (pendingWrites[toothID] === current) {
      delete pendingWrites[toothID];
    }
  };
  void current.then(release, release);
  return current;
};
